import { EnvironmentId } from '@/react/portainer/environments/types';
import axios from '@/portainer/services/axios';
import {
  ContainerId,
  ContainerListViewModel,
} from '@/react/docker/containers/types';

interface ContainerStartOptions {
  CheckpointID: string;
  CheckpointDir: string;
}

interface ContainerRemoveOptions {
  RemoveVolumes: boolean;
  RemoveLinks: boolean;
  Force: boolean;
}

interface CreateContainerCommandRequest {
  ContainerName: string;
  ContainerStartOptions?: ContainerStartOptions;
  ContainerRemoveOptions?: ContainerRemoveOptions;
  ContainerOperation: string;
}

export async function startContainer(
  environmentId: EnvironmentId,
  id: ContainerId
) {
  const payload: CreateContainerCommandRequest = {
    ContainerName: id,
    ContainerOperation: 'start',
  };

  await axios.post<void>(urlBuilder(environmentId), payload);
}

export async function stopContainer(
  endpointId: EnvironmentId,
  id: ContainerId
) {
  const payload: CreateContainerCommandRequest = {
    ContainerName: id,
    ContainerOperation: 'stop',
  };

  await axios.post<void>(urlBuilder(endpointId), payload);
}

export async function restartContainer(
  endpointId: EnvironmentId,
  id: ContainerId
) {
  const payload: CreateContainerCommandRequest = {
    ContainerName: id,
    ContainerOperation: 'restart',
  };

  await axios.post<void>(urlBuilder(endpointId), payload);
}

export async function killContainer(
  endpointId: EnvironmentId,
  id: ContainerId
) {
  const payload: CreateContainerCommandRequest = {
    ContainerName: id,
    ContainerOperation: 'kill',
  };
  await axios.post<void>(urlBuilder(endpointId), payload);
}

export async function removeContainer(
  endpointId: EnvironmentId,
  container: ContainerListViewModel,
  removeVolumes: boolean
) {
  const payload: CreateContainerCommandRequest = {
    ContainerName: container.Id,
    ContainerOperation: 'delete',
    ContainerRemoveOptions: {
      RemoveVolumes: removeVolumes,
      RemoveLinks: false,
      Force: true,
    },
  };
  await axios.post<void>(urlBuilder(endpointId), payload);
}

export function urlBuilder(endpointId: EnvironmentId) {
  return `/endpoints/${endpointId}/edge/async/commands/container`;
}
